export enum MediaLibraryEvents {
	SET_PAGINATED_VALUE = "[Set PAGINATED_VALUE] Action",
	SET_SEARCH_PAGINATED_VALUE = "[Set SEARCH_PAGINATED_VALUE] Action",
}
